/** The Privacy & security tabs, in order; the first opens when the address names none. */
export const TAB_IDS = ['devices', 'shared', 'delete'] as const;

export type TabId = (typeof TAB_IDS)[number];

/** The tab an address's # opens: a known tab, else the first. */
export function tabForHash(hash: string): TabId {
  const id = hash.replace(/^#/, '');
  return (TAB_IDS as readonly string[]).includes(id) ? (id as TabId) : TAB_IDS[0];
}

/** Where a key moves in a row of `count` tabs (the WAI-ARIA tabs pattern), or null for a key that does not. */
export function tabAfterKey(index: number, key: string, count: number): number | null {
  switch (key) {
    case 'ArrowRight':
      return (index + 1) % count;
    case 'ArrowLeft':
      return (index - 1 + count) % count;
    case 'Home':
      return 0;
    case 'End':
      return count - 1;
    default:
      return null;
  }
}
